'use client';

import { IEnhancedImage, IFooter } from '@/.generated';
import ImageWrapper from '@/helpers/Wrappers/ImageWrapper/ImageWrapper';
import PlainTextWrapper from '@/helpers/Wrappers/PlainTextWrapper/PlainTextWrapper';
import { usePageReferenceUrl } from '@/lib/hooks/usePageReferenceUrl';
import { getCSLPAttributes } from '@/utils/type-guards';
import Link from 'next/link';
import { trackAdobeClick } from '@/utils/adobe/click';
import { stickyTileVariants } from './StickyTiles.styles';

export type StickyTileData = NonNullable<
  NonNullable<IFooter['sticky_tiles_section']>['pay_bill_tile']
>;

const { tileWrapper, tileLink, tileLabel } = stickyTileVariants();

export const StickyTile = ({ tile }: { tile?: StickyTileData }) => {
  const href = usePageReferenceUrl(tile?.page_reference, tile?.link?.href);

  if (!tile?.icon?.url && !href) return null;

  // Fire the Adobe Click event for the sticky tile CTA
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    trackAdobeClick(
      { clickName: tile?.link?.title || 'Sticky Tile', clickLocation: 'Sticky-Tiles', clickType: 'sticky-tile-link' },
      e
    );
  };

  return (
    <div
      className={tileWrapper()}
      style={{
        backgroundColor: tile?.tile_background_color?.color_list ?? undefined,
        color: tile?.tile_text_color?.color_list ?? undefined,
      }}
    >
      <Link data-key={tile?.link?.title?.replace(/ /g,'')} href={href ?? ''} onClick={handleClick} className={tileLink()} {...getCSLPAttributes(tile?.$?.link)}>
        <ImageWrapper
          image={
            {
              image: tile?.icon,
              alternate_text: tile?.link?.title,
              $: { image: tile?.$?.icon },
            } as IEnhancedImage
          }
          width="50%"
          height="auto"
        />
        <PlainTextWrapper content={tile?.link?.title} className={tileLabel()} />
      </Link>
    </div>
  );
};
